export const API_ROOT = process.env.REACT_APP_HOST + process.env.REACT_APP_API_ROOT;

/** FE routes definitions */
export const FE_ROUTES = {
  KEYCLOAK_AUTH: '/',
  HOME: '/home',
  LOGINJUMP: 'login-jump',
  RESET_PASSWORD: '/reset-password'
};

/** API Path Definitions */
export const API_PATH = {
  GET_MENU: '/menu/theme/',
  GET_HALLOFFAMES: '/hall-of-fame/all-hall-of-fames/',
  CREATE_HALLOFFAMER: '/hall-of-fame/hall-of-fame/',
  DELETE_HALLOFFAMER: '/hall-of-fame/hall-of-fame-by-id/',
  LIKE_HALLOFFAMER: '/hall-of-fame/hall-of-fame-like/',
  APPROVE_HALLOFFAMER: '/hall-of-fame/approve-hall-of-fame-by-id/',
  GET_AVALIABLE_JIRA_SPRINT: '/release/sprint-select-list',
  RELEASE_SPRINT: '/release/',
  GET_ALL_CURRENT_RELEASE: '/release/current-release',
  PROJECT: '/project/',
  PROJECT_SUMMAR: '/project-summary/',
  PROJECT_STATUS: '/health/async-by-project-id/',
  PROJECT_HEALTH: '/health/health-list-by-project-status',
  ORGANIZATION_ORGANIZATIONS: '/organization/organizations/',
  PROJECT_BASICINFO: '/project/project-basic-info-r/',
  PROJECT_ALL: '/project/project-by-all/',
  UPDATE_PROJECT_BASICINFO: '/project/project-basic-info/',
  GET_ALL_SCRUM_TEAMS: '/scrum-team/scrum-teams-by-all',
  GET_SCRUM_TEAMS: '/scrum-team/scrum-teams/',
  UPDATE_SCRUM_TEAMS: '/scrum-team/',
  PROJECT_MANAGERS: '/project-manager/managers-r/',
  GET_DEVMETRICS: '/dev-metric/dev-metrics/',
  QA_MANAGEMENT_SUMMARY: '/issue/qa-management-summary',
  CADENCE_CHART_SUMMARY: '/issue/cadence-summary',
  UpdateStoryCycleTimeThreshold: '/issue/update-story-cycle-time-threshold',
  UpdateSprintNotes: '/issue/update-sprint-notes',
  GET_RULE_VALUE_TARGET: '/issue/rule-value',
  BASE_QA_CHART_SETTING: '/project-chart-filter',
  CREATE_DELETE_DEVMETRIC: '/dev-metric/',
  UPDATE_DEVMETRIC: '/dev-metric/dev-metric/',
  GET_DEVCHARTS: '/dev-chart/',
  UPDATE_USER_LOGOUT: '/user-management/user-logout/',
  GET_MESSAGES: '/message',
  UPDATE_MESSAGES: '/message',
  GET_UNREAD_MESSAGE_COUNT: '/message/unread-count/',
  GET_MESSAGE_COUNTS: '/message/counts',
  GET_USER_INFOS: '/user-management/user-infos/',
  USER_INFO: '/user-management/user-info/',
  USER_ALLOCATION: '/user-management/user-allocation/',
  USER_ALLOCATION_MANY: '/user-allocation/many',
  GET_USER_ROLES: '/user-management/roles/',
  GET_USER_PERMISSIONS: '/user-management/permissions-by-user-id/',
  UPDATE_USER_ROLE_ADD: '/user-management/user-role-add/',
  UPDATE_USER_ROLE_DELETE: '/user-management/user-role-delete/',
  USER_TYPE_ALLOCATION: '/user-info/user-type-allocation/',
  GET_PROJECT_ROLES: '/project-role/',
  GET_RULE_HISTORY: '/rule/rule-history-by-project-id/',
  UPDATE_RULE_HISTORY: '/rule/threshold-values/',
  GET_ROSTER_OVERVIEW: '/user-info/roster-over-view',
  UPDATE_PROJECT_HEALTH: '/health/',
  UPDATE_USERINFO_AVATAR: '/user-management/user-info-avatar/',
  GET_ALL_DICTTYPE: '/dict-type/dict-types/',
  GET_USER_PROJECTS_CURRENT_SPRINT: '/user-management/user-project-current-sprint/',
  MENU_QUICK_ACTION: '/menu-quick-action/',
  DELETE_MENU_QUICK_ACTIONS: '/menu-quick-action/deleteIds/',
  ALL_PROJECT_RISKDAYS: '/risk/projects-risk-days',
  ALL_PROJECT_CURRENT_MILESTONE: '/milestone/current-mile-stones',
  ALL_MILESTONE_RISKDAYS: '/milestone/mile-stone-risk-days',
  ALL_SPRINT_RISKDAYS: '/release/release-longest-risk-days',
  ALL_PROJECT: '/user-management/projects',
  SPRINT_ASSESSMENT_SETTINGS: '/assessment-setting/assessment-settings',
  DELETE_SPRINT_ASSESSMENT_SETTINGS: '/assessment-setting/',
  GET_ASSESSMENT_MAX_VERSION_BY_PROJECT: '/assessment-setting/max-version-by-project',
  UPDATE_SPRINT_ASSESSMENT_SETTINGS: '/assessment-setting/batch',
  GET_LATEST_ASSESSMENT_VERSION: '/assessment-setting/last12Retro-use-assessment-info',
  MAX_VERSION_USED: '/assessment-setting/max-version-weather-used',
  RETRO_ASSESSMENT_STATUS: '/assessment-score/status',
  SPRINT_ASSESSMENT_ANALYSIS: '/assessment-score/category-average-score',
  SPRINT_ASSESSMENT_ANALYSIS_SENTIMENT: '/assessment-score/question-score-percent',
  GET_SPRINT_ASSESSMENT: '/assessment-score/category-average-score',
  GET_SPRINT_ASSESSMENT_DETAILS: '/assessment-score/question-average-score',
  COMMENTDETAILS: '/assessment-score/comment-details',
  SENTIMENTDISTRIBUTIONS: '/assessment-score/sentiment-distributions',
  GET_RETRO_CATEGORIES_CONSISTENT: '/assessment-score/are-retro-categories-consistent',
  ASSESSMENT_TRENDS_OVER_TIME: '/assessment-score/assessment-trends-over-time',
  SYNC_USER_FROM_KEYCLOAK: '/user-management/sync-users-from-keycloak',
  CLONE_PERMISSIONS_BATCH: '/user-management/clone-user-permissions-batch',
  USER_ROLES_DETAIL: '/user-management/user-roles-detail',
  USER_MARKET_CODE_LIST: '/user-management/user-market-code-list',
  BILLING_INVOICE: '/billing-invoice',
  BILLING_INVOICE_BY_ID: '/billing-invoice/',
  BILLING_ANALYSIS_KPIS: '/billing-analysis/kpis',
  BILLING_ANALYSIS_COST_DISTRIBUTION: '/billing-analysis/cost-distribution',
  BILLING_ANALYSIS_MONTHLY_COST_DISTRIBUTION: '/billing-analysis/monthly-cost-distribution',
  BILLING_ANALYSIS_MONTHLY_INVOICE_DETAILS: '/billing-analysis/monthly-invoice-details',
  BILLING_ANALYSIS_SP_AND_COST: '/billing-analysis/sp-and-cost',
  BILLING_ANALYSIS_SP_CATEGORY_COMPOSITION: '/billing-analysis/sp-category-composition',
  BILLING_ANALYSIS_MONTHLY_INVOICE_OVERVIEW: '/billing-analysis/monthly-invoice-overview',
  BILLING_ANALYSIS_MONTHLY_INVOICE_ACCOUNTS: '/billing-analysis/monthly-invoice-accounts',
  BILLING_ANALYSIS_MARKET_CODE_GROUPS: '/billing-analysis/market-code-groups',
  SCRUMTEAMMEMBER: '/scrum-team-member',
  UPDATESCRUMTEAMMEMBER: '/scrum-team-member/',
  GET_USER_INFOS_MANANGE: '/user-info/user-managements',
  PASSWORD_RESET_REQUEST_CODE: '/api/app/password-reset/request-code',
  PASSWORD_RESET_RESET: '/api/app/password-reset/reset',
  /** Incident Analysis */
  INCIDENT_MATRIX_STATS: '/incident-overview/matrix-stats',
  INCIDENT_MATRIX_CHART: '/incident-overview/matrix-chart',
  INCIDENT_OVERVIEW_PERFORMERS: '/incident-overview/performers',
  INCIDENT_OVERVIEW_CATEGORIES: '/incident-overview/category-stats',
  GET_USER_INFOS_MANANGE: '/user-info/user-managements',
  STATUS_MONITOR: '/project-home/status-monitor',
  ACTIVE_SPRINTS: '/project-home/active-sprints',
  EFFICIENCY_RANKING: '/project-home/efficiency-ranking',
  DELIVERY_STATUS: '/project-home/delivery-status',
  TEAM_COMPOSITION: '/project-home/team-composition',
  PROJECT_HOME_PROJECT_SUMMARY: '/project-home/project-summary',
  QA_KANBAN_BUG_BACKLOG: '/qa-charts-kan-ban/bug-backlog',
  QA_KANBAN_QA_CREATED: '/qa-charts-kan-ban/qa-created',
  QA_KANBAN_INCIDENT_PRODUCT: '/qa-charts-kan-ban/incident-product',
  QA_KANBAN_AUTOMATION_STATUS: '/qa-charts-kan-ban/automation-status',
  BILLING_INVOICE: '/billing-invoice',
  BILLING_INVOICE_BILL_TOS: '/billing-invoice/bill-tos',
  BILLING_INVOICE_UPLOAD: '/billing-invoice/upload',
  BILLING_INVOICE_UPLOAD_SUBMIT: '/billing-invoice/upload-submit',
  BILLING_INVOICE_IMPORT_PREVIEW: '/billing-invoice/import-preview',
  BILLING_INVOICE_SAVE_PREVIEW: '/billing-invoice/save-preview',
  BILLING_INVOICE_GROUP: '/billing-invoice/group',
  GET_SUB_APPLICATION_LIST: '/sub-application',
  GET_SUB_APP_ROLE_ASSIGN: '/sub-app-role-assign',
  GET_GROUPS: '/sub-app-role-assign/groups',
  GET_SUB_APP_ROLE_ASSIGN_ASSIGNED_ROLES: '/sub-app-role-assign/assigned-roles',
  POST_SUB_APP_ROLE_ASSIGN: '/sub-app-role-assign/assign',
  GET_GROUP_ROLE_ASSIGN_ASSIGNED_ROLES: '/sub-app-role-assign/group-assigned-roles',
  GET_GROUP_ASSIGNED_ROLES_BY_USER_ID: '/sub-app-role-assign/group-assigned-roles-by-user-id',
  GET_MY_ACCESSIBLE_SUB_APPLICATIONS: '/sub-app-role-assign/my-accessible-sub-applications',
  POST_GROUP_ROLE_ASSIGN: '/sub-app-role-assign/assign-group',
  GET_PLATFORM_DATA_HUB_PERMISSION: '/platform-data-hub/permission',
  CREATE_SUB_APPLICATION: '/sub-application',
  UPDATE_SUB_APPLICATION: '/sub-application/',
  ACTIVE_SUB_APPLICATION: '/sub-application/',
  GET_SUB_APPLICATION_DETAIL: '/sub-application/',
  GET_SUB_APPLICATION_DEFAULT: '/sub-application/default'
};

/** Password Reset API (anonymous, no auth header) */
export const PASSWORD_RESET_REQUEST_CODE = `${process.env.REACT_APP_HOST}${API_PATH.PASSWORD_RESET_REQUEST_CODE}`;
export const PASSWORD_RESET_RESET = `${process.env.REACT_APP_HOST}${API_PATH.PASSWORD_RESET_RESET}`;

/** Billing Center Invoice API */
export const BILLING_INVOICE_BILL_TOS = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_BILL_TOS}`;
export const BILLING_INVOICE_UPLOAD = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_UPLOAD}`;
export const BILLING_INVOICE_UPLOAD_SUBMIT = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_UPLOAD_SUBMIT}`;
export const BILLING_INVOICE_IMPORT_PREVIEW = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_IMPORT_PREVIEW}`;
export const BILLING_INVOICE_SAVE_PREVIEW = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_SAVE_PREVIEW}`;
export const BILLING_INVOICE_GROUP = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_GROUP}`;

/** * welcome page */
export const GET_USER_PROJECTS_CURRENT_SPRINT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_USER_PROJECTS_CURRENT_SPRINT}`;
export const MENU_QUICK_ACTION = `${process.env.REACT_APP_API_ROOT}${API_PATH.MENU_QUICK_ACTION}`;
export const DELETE_MENU_QUICK_ACTIONS = `${process.env.REACT_APP_API_ROOT}${API_PATH.DELETE_MENU_QUICK_ACTIONS}`;

/** Request api Definitions */
export const GET_MENU = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_MENU}`;
// Menu theme latest (added)
export const GET_MENU_THEME_LATEST = `${process.env.REACT_APP_API_ROOT}/menu-theme/latest`;
export const SAVE_MENU_THEME = `${process.env.REACT_APP_API_ROOT}/menu-theme`;
// Full menu list for modal editing
export const GET_MENU_FULL = `${process.env.REACT_APP_API_ROOT}/menu/full-menu`;
export const GET_HALLOFFAMES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_HALLOFFAMES}`;
export const CREATE_HALLOFFAMER = `${process.env.REACT_APP_API_ROOT}${API_PATH.CREATE_HALLOFFAMER}`;
export const DELETE_HALLOFFAMER = `${process.env.REACT_APP_API_ROOT}${API_PATH.DELETE_HALLOFFAMER}`;
export const GET_MESSAGES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_MESSAGES}`;
export const UPDATE_MESSAGES = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_MESSAGES}`;
export const GET_UNREAD_MESSAGE_COUNT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_UNREAD_MESSAGE_COUNT}`;
export const GET_MESSAGE_COUNTS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_MESSAGE_COUNTS}`;

/** sprint grid API */
export const GET_AVALIABLE_JIRA_SPRINT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_AVALIABLE_JIRA_SPRINT}`;
export const CREATE_SPRINT = `${process.env.REACT_APP_API_ROOT}${API_PATH.RELEASE_SPRINT}`;

/** usermanagement API */
export const GET_USER_INFOS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_USER_INFOS}`;
export const USER_INFO = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_INFO}`;
export const USER_ALLOCATION = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_ALLOCATION}`;
export const USER_ALLOCATION_MANY = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_ALLOCATION_MANY}`;
export const GET_USER_ROLES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_USER_ROLES}`;
export const GET_USER_PERMISSIONS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_USER_PERMISSIONS}`;
export const UPDATE_USER_ROLE_ADD = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_USER_ROLE_ADD}`;
export const UPDATE_USER_ROLE_DELETE = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_USER_ROLE_DELETE}`;
export const GET_PROJECT_ROLES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_PROJECT_ROLES}`;
export const UPDATE_USER_LOGOUT = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_USER_LOGOUT}`;
export const SYNC_USER_FROM_KEYCLOAK = `${process.env.REACT_APP_API_ROOT}${API_PATH.SYNC_USER_FROM_KEYCLOAK}`;
export const GET_ROSTER_OVERVIEW = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_ROSTER_OVERVIEW}`;
export const CLONE_PERMISSIONS_BATCH = `${process.env.REACT_APP_API_ROOT}${API_PATH.CLONE_PERMISSIONS_BATCH}`;
export const USER_ROLES_DETAIL = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_ROLES_DETAIL}`;
export const GET_SUB_APP_ROLE_ASSIGN = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SUB_APP_ROLE_ASSIGN}`;
export const GET_GROUPS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_GROUPS}`;
export const GET_SUB_APP_ROLE_ASSIGN_ASSIGNED_ROLES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SUB_APP_ROLE_ASSIGN_ASSIGNED_ROLES}`;
export const POST_SUB_APP_ROLE_ASSIGN = `${process.env.REACT_APP_API_ROOT}${API_PATH.POST_SUB_APP_ROLE_ASSIGN}`;
export const GET_GROUP_ROLE_ASSIGN_ASSIGNED_ROLES = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_GROUP_ROLE_ASSIGN_ASSIGNED_ROLES}`;
export const GET_GROUP_ASSIGNED_ROLES_BY_USER_ID = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_GROUP_ASSIGNED_ROLES_BY_USER_ID}`;
export const GET_MY_ACCESSIBLE_SUB_APPLICATIONS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_MY_ACCESSIBLE_SUB_APPLICATIONS}`;
export const POST_GROUP_ROLE_ASSIGN = `${process.env.REACT_APP_API_ROOT}${API_PATH.POST_GROUP_ROLE_ASSIGN}`;

/** HALL OF FAMER API*/
export const LIKE_HALLOFFAMER = `${process.env.REACT_APP_API_ROOT}${API_PATH.LIKE_HALLOFFAMER}`;
export const APPROVE_HALLOFFAMER = `${process.env.REACT_APP_API_ROOT}${API_PATH.APPROVE_HALLOFFAMER}`;
export const GET_PROJECT = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT}`;
export const GET_PROJECT_SUMMARY = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_SUMMAR}`;
export const GET_PROJECT_STATUS = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_STATUS}`;
export const GET_ORGANIZATION_ORGANIZATIONS = `${process.env.REACT_APP_API_ROOT}${API_PATH.ORGANIZATION_ORGANIZATIONS}`;
export const PROJECT_BASICINFO = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_BASICINFO}`;
export const UPDATE_PROJECT_BASICINFO = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_PROJECT_BASICINFO}`;
export const PROJECT_ALL = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_ALL}`;

export const GET_SCRUM_TEAMS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SCRUM_TEAMS}`;
export const UPDATE_SCRUM_TEAMS = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_SCRUM_TEAMS}`;
export const PROJECT_MANAGERS = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_MANAGERS}`;

export const GET_RULE_HISTORY = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_RULE_HISTORY}`;
export const UPDATE_RULE_HISTORY = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_RULE_HISTORY}`;
export const UPDATE_PROJECT_HEALTH = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_PROJECT_HEALTH}`;

/** DEV METRICS API*/
export const GET_DEVMETRICS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_DEVMETRICS}`;
export const CREATE_DELETE_DEVMETRIC = `${process.env.REACT_APP_API_ROOT}${API_PATH.CREATE_DELETE_DEVMETRIC}`;
export const UPDATE_DEVMETRIC = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_DEVMETRIC}`;

/** QA Charts APIs */
export const GET_QA_MANAGEMENT_SUMMARY = `${process.env.REACT_APP_API_ROOT}${API_PATH.QA_MANAGEMENT_SUMMARY}`;
export const GET_QA_CHART_SETTING = `${process.env.REACT_APP_API_ROOT}${API_PATH.BASE_QA_CHART_SETTING}/qa-management-chart-settings`;
export const BASE_QA_CHART_SETTING = `${process.env.REACT_APP_API_ROOT}${API_PATH.BASE_QA_CHART_SETTING}`;
export const GET_RULE_VALUE_TARGET = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_RULE_VALUE_TARGET}`;

/** Cadence Chart APIs */
export const GET_CADENCE_CHART_SUMMARY = `${process.env.REACT_APP_API_ROOT}${API_PATH.CADENCE_CHART_SUMMARY}`;
export const UpdateStoryCycleTimeThreshold = `${process.env.REACT_APP_API_ROOT}${API_PATH.UpdateStoryCycleTimeThreshold}`;
export const UpdateSprintNotes = `${process.env.REACT_APP_API_ROOT}${API_PATH.UpdateSprintNotes}`;

export const USER_MARKET_CODE_LIST = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_MARKET_CODE_LIST}`;

/** Billing Analysis APIs */
export const BILLING_INVOICE = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE}`;
export const BILLING_INVOICE_BY_ID = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_INVOICE_BY_ID}`;
export const BILLING_ANALYSIS_KPIS = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_KPIS}`;
export const BILLING_ANALYSIS_COST_DISTRIBUTION = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_COST_DISTRIBUTION}`;
export const BILLING_ANALYSIS_MONTHLY_COST_DISTRIBUTION = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_MONTHLY_COST_DISTRIBUTION}`;
export const BILLING_ANALYSIS_MONTHLY_INVOICE_DETAILS = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_MONTHLY_INVOICE_DETAILS}`;
export const BILLING_ANALYSIS_SP_AND_COST = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_SP_AND_COST}`;
export const BILLING_ANALYSIS_SP_CATEGORY_COMPOSITION = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_SP_CATEGORY_COMPOSITION}`;
export const BILLING_ANALYSIS_MONTHLY_INVOICE_OVERVIEW = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_MONTHLY_INVOICE_OVERVIEW}`;
export const BILLING_ANALYSIS_MONTHLY_INVOICE_ACCOUNTS = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_MONTHLY_INVOICE_ACCOUNTS}`;
export const BILLING_ANALYSIS_MARKET_CODE_GROUPS = `${process.env.REACT_APP_API_ROOT}${API_PATH.BILLING_ANALYSIS_MARKET_CODE_GROUPS}`;

export const GET_SPRINT_ASSESSMENT_SETTINGS = `${process.env.REACT_APP_API_ROOT}${API_PATH.SPRINT_ASSESSMENT_SETTINGS}`;
export const UPDATE_SPRINT_ASSESSMENT_SETTINGS = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_SPRINT_ASSESSMENT_SETTINGS}`;
export const MAX_VERSION_USED = `${process.env.REACT_APP_API_ROOT}${API_PATH.MAX_VERSION_USED}`;
export const GET_SPRINT_ASSESSMENT_ANALYSIS = `${process.env.REACT_APP_API_ROOT}${API_PATH.SPRINT_ASSESSMENT_ANALYSIS}`;
export const SPRINT_ASSESSMENT_ANALYSIS_SENTIMENT = `${process.env.REACT_APP_API_ROOT}${API_PATH.SPRINT_ASSESSMENT_ANALYSIS_SENTIMENT}`;
export const ASSESSMENT_TRENDS_OVER_TIME = `${process.env.REACT_APP_API_ROOT}${API_PATH.ASSESSMENT_TRENDS_OVER_TIME}`;
export const GET_LATEST_ASSESSMENT_VERSION = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_LATEST_ASSESSMENT_VERSION}`;

export const GET_RETRO_ASSESSMENT_STATUS = `${process.env.REACT_APP_API_ROOT}${API_PATH.RETRO_ASSESSMENT_STATUS}`;
export const GET_COMMENT_DETAILS = `${process.env.REACT_APP_API_ROOT}${API_PATH.COMMENTDETAILS}`;
export const GET_SENTIMENT_DISTRIBUTIONS = `${process.env.REACT_APP_API_ROOT}${API_PATH.SENTIMENTDISTRIBUTIONS}`;

export const GET_ASSESSMENT_MAX_VERSION_BY_PROJECT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_ASSESSMENT_MAX_VERSION_BY_PROJECT}`;

/** DEV CHARTS API*/
export const GET_DEVCHARTS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_DEVCHARTS}`;

/** Dashboard  series APIs definitions */
export const REDIRECT_URI_ROOT = process.env.REACT_APP_REDIRECT_URI_LOGOUT;

export const LOGINT_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI_LOGOUT + FE_ROUTES.HOME;
export const LOGINT_REDIRECT_URI_NEW = `${process.env.REACT_APP_REDIRECT_URI_LOGOUT}/${FE_ROUTES.LOGINJUMP}`;

/** keycloak series APIs definitions */
export const KEYCLOAK_TOKEN_API = process.env.REACT_APP_TOKEN_API;

/** User info APIs definitions */
export const UPDATE_USERINFO_AVATAR = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_USERINFO_AVATAR}`;

/** Field Management */
export const GET_ALL_DICTTYPE = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_ALL_DICTTYPE}`;

/** Executive summary */
export const GET_PROJECT_HEALTH_BY_PROJECT_STATUS = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_HEALTH}`;
export const GET_USER_TYPE_ALLOCATION = `${process.env.REACT_APP_API_ROOT}${API_PATH.USER_TYPE_ALLOCATION}`;
export const GET_ALL_SCRUM_TEAMS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_ALL_SCRUM_TEAMS}`;
export const GET_ALL_CURRENT_RELEASE = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_ALL_CURRENT_RELEASE}`;
export const GET_ALL_PROJECT_RISKDAYS = `${process.env.REACT_APP_API_ROOT}${API_PATH.ALL_PROJECT_RISKDAYS}`;
export const GET_ALL_PROJECT_MILESTONE = `${process.env.REACT_APP_API_ROOT}${API_PATH.ALL_PROJECT_CURRENT_MILESTONE}`;
export const GET_ALL_MILESTONE_RISKDAYS = `${process.env.REACT_APP_API_ROOT}${API_PATH.ALL_MILESTONE_RISKDAYS}`;
export const GET_ALL_SPRINT_RISKDAYS = `${process.env.REACT_APP_API_ROOT}${API_PATH.ALL_SPRINT_RISKDAYS}`;
export const GET_ALL_PROJECT = `${process.env.REACT_APP_API_ROOT}${API_PATH.ALL_PROJECT}`;

export const GET_SPRINT_ASSESSMENT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SPRINT_ASSESSMENT}`;
export const GET_SPRINT_ASSESSMENT_DETAILS = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SPRINT_ASSESSMENT_DETAILS}`;

export const SCRUMTEAMMEMBER = `${process.env.REACT_APP_API_ROOT}${API_PATH.SCRUMTEAMMEMBER}`;
export const UPDATESCRUMTEAMMEMBER = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATESCRUMTEAMMEMBER}`;
export const GET_USER_INFOS_MANANGE = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_USER_INFOS_MANANGE}`;

/** Incident Analysis API */
export const INCIDENT_MATRIX_STATS = `${process.env.REACT_APP_API_ROOT}${API_PATH.INCIDENT_MATRIX_STATS}`;
export const INCIDENT_MATRIX_CHART = `${process.env.REACT_APP_API_ROOT}${API_PATH.INCIDENT_MATRIX_CHART}`;
export const INCIDENT_OVERVIEW_PERFORMERS = `${process.env.REACT_APP_API_ROOT}${API_PATH.INCIDENT_OVERVIEW_PERFORMERS}`;
export const INCIDENT_OVERVIEW_CATEGORIES = `${process.env.REACT_APP_API_ROOT}${API_PATH.INCIDENT_OVERVIEW_CATEGORIES}`;

/** Home Kanban APIs */
export const GET_STATUS_MONITOR = `${process.env.REACT_APP_API_ROOT}${API_PATH.STATUS_MONITOR}`;
export const GET_ACTIVE_SPRINTS = `${process.env.REACT_APP_API_ROOT}${API_PATH.ACTIVE_SPRINTS}`;
export const GET_EFFICIENCY_RANKING = `${process.env.REACT_APP_API_ROOT}${API_PATH.EFFICIENCY_RANKING}`;
export const GET_DELIVERY_STATUS = `${process.env.REACT_APP_API_ROOT}${API_PATH.DELIVERY_STATUS}`;
export const GET_TEAM_COMPOSITION = `${process.env.REACT_APP_API_ROOT}${API_PATH.TEAM_COMPOSITION}`;
export const PROJECT_HOME_PROJECT_SUMMARY = `${process.env.REACT_APP_API_ROOT}${API_PATH.PROJECT_HOME_PROJECT_SUMMARY}`;
export const GET_QA_KANBAN_BUG_BACKLOG = `${process.env.REACT_APP_API_ROOT}${API_PATH.QA_KANBAN_BUG_BACKLOG}`;
export const GET_QA_KANBAN_QA_CREATED = `${process.env.REACT_APP_API_ROOT}${API_PATH.QA_KANBAN_QA_CREATED}`;
export const GET_QA_KANBAN_INCIDENT_PRODUCT = `${process.env.REACT_APP_API_ROOT}${API_PATH.QA_KANBAN_INCIDENT_PRODUCT}`;
export const GET_QA_KANBAN_AUTOMATION_STATUS = `${process.env.REACT_APP_API_ROOT}${API_PATH.QA_KANBAN_AUTOMATION_STATUS}`;

/** Sub-application APIs */
export const GET_SUB_APPLICATION_LIST = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SUB_APPLICATION_LIST}`;
export const CREATE_SUB_APPLICATION = `${process.env.REACT_APP_API_ROOT}${API_PATH.CREATE_SUB_APPLICATION}`;
export const UPDATE_SUB_APPLICATION = `${process.env.REACT_APP_API_ROOT}${API_PATH.UPDATE_SUB_APPLICATION}`;
export const ACTIVE_SUB_APPLICATION = `${process.env.REACT_APP_API_ROOT}${API_PATH.ACTIVE_SUB_APPLICATION}`;
export const GET_SUB_APPLICATION_DETAIL = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SUB_APPLICATION_DETAIL}`;
export const GET_SUB_APPLICATION_DEFAULT = `${process.env.REACT_APP_API_ROOT}${API_PATH.GET_SUB_APPLICATION_DEFAULT}`;
export const GET_PLATFORM_DATA_HUB_PERMISSION = `${process.env.REACT_APP_PROXY_URL}${API_PATH.GET_PLATFORM_DATA_HUB_PERMISSION}`;
